import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import CattlesApiService from 'services/cattlesApiServices'
import {
	IMilkYieldChartRequest,
	IMilkYieldChartResponse,
} from '../../models/IMilkYieldChartTypes'

const formatedDateTotaticString = (tm: number) => {
	return moment(tm).format('DD.MM.YYYY HH')
}

export const useGetMilkYieldChart = ({
	start,
	end,
	barn_id,
	group_id,
}: IMilkYieldChartRequest) => {
	const { data, isError, isLoading } = useQuery({
		queryKey: [
			'milk-yield-chart-info',
			formatedDateTotaticString(start),
			formatedDateTotaticString(end),
			barn_id,
			group_id,
		],
		queryFn: async () => {
			return await CattlesApiService.getMilkYieldChartInfo({
				start,
				end,
				barn_id,
				group_id,
			})
		},
		staleTime: 50000,
	})
	return { data, isError, isLoading }
}
const obj: IMilkYieldChartResponse = {
	total_sell_milk_sum: 94.3,
	total_reject_milk_sum: 11.7,
	cow_count: 168,
	graph: [
		{
			date: 1753218000000, // понедельник
			milkings: [
				{ sell_milk_amount: 13.2, reject_milk_amount: 1.1, period: 'am' },
				{ sell_milk_amount: 12.8, reject_milk_amount: 0.4, period: 'pm' },
			],
			sell_milk_sum: 26,
			reject_milk_sum: 1.5,
		},
		{
			date: 1753304400000, // вторник
			milkings: [
				{ sell_milk_amount: 14.1, reject_milk_amount: 0.6, period: 'am' },
				{ sell_milk_amount: 13.7, reject_milk_amount: 0.9, period: 'pm' },
			],
			sell_milk_sum: 27.8,
			reject_milk_sum: 1.5,
		},
		{
			date: 1753390800000, // среда
			milkings: [
				{ sell_milk_amount: 12.0, reject_milk_amount: 2.3, period: 'am' },
				{ sell_milk_amount: 13.5, reject_milk_amount: 1.0, period: 'pm' },
			],
			sell_milk_sum: 25.5,
			reject_milk_sum: 3.3,
		},
		{
			date: 1753477200000, // четверг
			milkings: [],
			sell_milk_sum: 0,
			reject_milk_sum: 0,
		},
		{
			date: 1753563600000, // пятница
			milkings: [
				{ sell_milk_amount: 11.0, reject_milk_amount: 1.4, period: 'am' },
			],
			sell_milk_sum: 11.0,
			reject_milk_sum: 1.4,
		},
		{
			date: 1753650000000, // суббота
			milkings: [
				{ sell_milk_amount: 15.5, reject_milk_amount: 0, period: 'pm' },
			],
			sell_milk_sum: 15.5,
			reject_milk_sum: 0,
		},
		{
			date: 1753736400000, // воскресенье
			milkings: [],
			sell_milk_sum: 0,
			reject_milk_sum: 0,
		},
	],
}
